<template>
    <div class="compose-box media note-editor">
        <div class="media-content">
            <div style="display: flex; align-items: center; width: 100%">
              <o-field class="field-autocomplete" style="width: 100%" label="To  ">
                <multiselect
                    :model-value="message_object.to"
                    @update:modelValue="message_object.to = $event"
                    value-prop="email"
                    label="full_name"
                    placeholder="To"
                    ref="to"
                    track-by="full_name"
                    :options="options"
                    mode="tags"
                    :create-option="true"
                    :searchable="true"
                    class="input"
                    @search-change="(query) => autocomplete_contacts('to', query)"

                >
                  <template v-slot:option="{ option }">
                    <div>
                      {{ option.full_name }} (<small>{{ option.email }}</small>)
                    </div>
                  </template>
                </multiselect>
              </o-field>
              <div class="bcc-cc" v-show="!cc_enabled || !bcc_enabled">
                <a
                    href=""
                    @click.prevent="cc_enabled = true"
                    v-show="!cc_enabled"
                >Cc</a
                >
                <a
                    href=""
                    @click.prevent="bcc_enabled = true"
                    v-show="!bcc_enabled"
                >Bcc</a
                >
            </div>
          </div>
            <o-field class="field-autocomplete" label="Cc  " v-show="cc_enabled">
                <multiselect
                    v-model:model-value="message_object.cc"
                    @update:modelValue="message_object.cc = $event"
                    value-prop="email"
                    label="full_name"
                    placeholder="Cc"
                    track-by="full_name"
                    :options="options"
                    :mode="'tags'"
                    :create-option="true"
                    :searchable="true"
                    class="input"
                />
            </o-field>
            <o-field
                class="field-autocomplete"
                label="Bcc  "
                v-show="bcc_enabled"
            >
                <multiselect
                    v-model:model-value="message_object.bcc"
                    @update:modelValue="message_object.bcc = $event"
                    value-prop="email"
                    label="full_name"
                    placeholder="Bcc"
                    track-by="full_name"
                    :options="allUsers"
                    :mode="'tags'"
                    :create-option="true"
                    :searchable="true"
                    class="input"
                />
            </o-field>
            <o-field label="">
                <o-input
                    v-model="message_object.subject"
                    placeholder="Subject"
                />
            </o-field>

            <div class="field">
<!--                <compose-editor v-model:value="message_object.body" />-->
<!--              <quill-editor ref="quill" v-model:content="message_object.replies" :content-type="'html'" :options="editorOptions" />-->
              <quill-editor ref="quill" v-model:content="message_object.body" :content-type="'html'" :options="editorOptions" />
<!--                <quill-editor ref="quill" :content="message_object.rep" :content-type="'text'" :options="editorOptions" />-->
<!--              <p>-->
<!--                <span v-html="message_object.body"></span>-->
<!--              </p>-->
            </div>
            <ul
                v-if="message_object.attaches && message_object.attaches.length"
            >
                <li v-for="(file, key) in message_object.attaches" :key="key">
                    <span class="icon is-small">
                        <i class="fa fa-file" />
                    </span>
                    <a
                        href=""
                        target="_blank"
                        @click.prevent="handle('open_file', file)"
                        >{{ file.name }}</a
                    >
                    <span>{{ $filters.readableSize(file.size) }}</span>
                    <span
                        class="icon is-small remove-attachment-button"
                        @click="handle('remove-attachment', file)"
                    >
                        <i class="fa fa-close" />
                    </span>
                </li>
            </ul>

            <div class="compose-box-buttons">
                <div class="">
                    <form style="display: none">
                        <input
                            class="button"
                            multiple
                            ref="file"
                            type="file"
                            @change="handle('file_change', $event)"
                        />
                    </form>
                    <button class="button" @click="handle('attach')">
                        <o-icon pack="fa" icon="paperclip"></o-icon>
                    </button>
                    <button class="button" @click="handle('discard')">
                        <o-icon pack="fa" icon="trash"></o-icon>
                    </button>
                </div>
                <div>
                    <button
                        v-submit="submitting"
                        class="button is-red is-danger button-danger"
                        @click.prevent="handle('cancel', $event)"
                    >
                        Save as draft
                    </button>
                    <send-email-button
                        :disabled="is_send_button_disabled"
                        @send="handle_send"
                        @send_scheduled="handle_schedule_send"
                        >{{
                            (is_send_button_disabled && "Loading...") || "Send"
                        }}</send-email-button
                    >
                </div>
            </div>
        </div>
        <o-modal
            :can-cancel="['escape', 'outside', 'button']"
            v-model:active="isPreviewModalActive"
            class="preview-modal"
            has-modal-card
        >
            <file-preview-modal :file="currentPreviewFile" />
        </o-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Multiselect from '@vueform/multiselect'
import {
    autocomplete_contacts,
    autocomplete_ordino_contacts,
    get_names_and_email,
    get_signature,
    send_email,
    send_scheduled,
} from '../gmail_api'
import { escapeHTML } from '../utils'
import ComposeEditor from './ComposeEditor'
import SendEmailButton from './SendEmailButton'
import AutocompleteContacts from '../AutocompleteContacts.vue'
import FilePreviewModal from './../components/modals/FilePreviewModal'
import {QuillEditor} from "@vueup/vue-quill";
import {reactive} from "vue";

export default {
    components: {
        QuillEditor,
        AutocompleteContacts,
        ComposeEditor,
        FilePreviewModal,
        Multiselect,
        SendEmailButton,
    },
    computed: {
        ...mapGetters([
            'emails_get_profile',
            'users'
        ]),
        original_message() {
            const { is_forward = false, is_reply = false, source_message = {} } = this.message
                , { body, date, from, subject, to } = source_message
                , forwarded_message = is_forward ? `---------- Forwarded message ---------<br>From: ${escapeHTML(from)}<br>Date: ${date}<br>Subject: ${subject}<br>To: ${escapeHTML(to)}<br><br>` : ''
            if (source_message && is_forward) {
                return `<br><br>${forwarded_message}${body}`
            }else if (is_reply) {
                const reply = `<div class="gmail_quote"><blockquote class="gmail_quote">${body}</blockquote>`
                return `${reply}`
            }
            else{
              return ''
            }
        },
        is_empty() {
            const { body, subject, } = this.message_object
            const { bcc = [], cc = [], to = [], } = this.message_object
            return (bcc.length === 0 && cc.length === 0 && to.length === 0) || (subject === '' && body === '')
        },
        is_send_button_disabled() {
            const { message } = this
            return message && (message.attaches || []).length && message.attaches.some(i => i.loading) || this.loading
        },
        profile() {
            return this.emails_get_profile || {}
        },
      allUsers() {
        return this.users
      }
    },
    data() {
        return {
            bcc_enabled: false,
            cc_enabled: false,
            currentPreviewFile: null,
            isPreviewModalActive: false,
            loading: false,
            message_object: {
                attaches: [],
                bcc: [],
                body: [],
                cc: [],
                subject: "",
                replies: "",
                from: '',
                to: [],
            },
            options: [],
            signature: '',
            submitting: false,
            value: {
                bcc: [],
                cc: [],
                to: [],
            },
          editorOptions: {
            modules: {
              toolbar: [
                [{ 'font': [] }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'align': [] }],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                ['clean'],
                ['blockquote', 'code-block'],
                [{ 'header': 1 }, { 'header': 2 }],
                // [{ 'script': 'sub'}, { 'script': 'super' }],
                //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['link'],
                ['image'],


              ],
            }
          },

        }
    },
    methods: {
        autocomplete_contacts: _.debounce(async function (type, q = '') {
          if (!q || q.length < 2) {
            return
          }
          const item = {email: q, name: q, type: 'typed-contact'},
              user = {email: this.profile.emailAddress, name: this.profile.name, type: 'contact'}
          this.options = []
          await Promise.allSettled([autocomplete_ordino_contacts(q)]
          ).then(res => {
            res.forEach(({value}) => {
              if (value && value.length) {
                this.options = [...this.options, ...value]
              }
            })
          })
        }, 250),
        get_label(item) {
            const { email, name, } = item
            return !!name && name !== email && `${name} - ${email}` || email
        },
        handle(type, e) {
            switch (type) {
                case 'attach':
                    this.$refs.file.click()
                    break
                case "cancel":
                    if (this.is_send_button_disabled) {
                        return
                    }
                    this.message_object.from = this.profile.emailAddress
                    !this.is_empty && send_email(this.message_object, true).then(res => {
                        this.reset()
                        this.$swal.fire({
                            text: 'Draft saved',
                            icon: 'success'
                        })
                        this.$emit("cancel", res)
                    }).catch(() => {
                      this.$swal.fire({
                            text: 'Error saving email to draft',
                            icon: 'danger'
                        })
                        this.$emit("cancel")
                    })
                    this.is_empty && this.$emit("cancel")
                    break
                case "discard":
                    this.reset()
                    this.$emit("cancel")
                    break
                case 'file_change':
                    const files = [...e.target.files]
                    if (Array.isArray(files)) {
                        files.forEach(file => {
                            const reader = new FileReader()
                            reader.readAsDataURL(file)
                            reader.onload = () => {
                              console.log(reader)
                                const attachment = {
                                    data_url: reader.result,
                                    base64: reader.result.replace(new RegExp(`^data:${file.type};base64,`), ''),
                                    name: file.name,
                                    size: file.size,
                                    type: file.type,
                                }
                                this.message_object.attaches = this.message_object.attaches || []
                                this.message_object.attaches.push(attachment)
                            }
                        })
                        this.$refs.file.parentNode.reset()
                    }
                    break
                case 'open_file':
                  console.log(e)
                    this.currentPreviewFile = e
                    this.isPreviewModalActive = true
                    break
                case 'remove-attachment':
                    this.message_object.attaches = this.message_object.attaches.filter(f => f.name !== e.name)
                    break
                default:
                    break
            }
        },
        handle_schedule_send(date) {
            if (this.is_send_button_disabled) {
                return
            }
            this.message_object.from = this.profile.emailAddress;
            // ['bcc', 'cc', 'to'].forEach(type => { this.message_object[type] = Object.entries(this.value[type]).map(i => `${i.name} <${i.email}>`.trim()) })
            if (!this.is_empty) {
                this.loading = true
                send_scheduled(this.message_object, date).then(res => {
                    this.$swal.fire({
                        text: 'The email has been scheduled successfull',
                        icon: 'success',
                    })
                    this.$emit("sent", res)
                    this.reset()
                  this.$emit('close', true)
                  this.$parent.$emit('close', true)
                }, () => {
                    this.$swal.fire({
                        text: 'Error sending the email',
                        icon: 'danger'
                    })
                }).then(() => {
                    this.loading = false
                })
            }
        },
        handle_send() {
            if (this.is_send_button_disabled) {
                return
            }
            this.message_object.from = this.profile.email;
            if (!this.is_empty) {
                this.loading = true
                send_email(this.message_object).then(res => {
                  this.$swal.fire({
                    text: 'The email has been sent successfull',
                    icon: 'success',
                  })
                  this.$emit("sent", res)
                  this.$emit('close', true)
                  this.$parent.$emit('close', true)
                }, () => {
                  this.$swal.fire({
                    text: 'Error sending the email',
                    icon: 'danger'
                  })
                    this.loading = false
                }).then(() => {
                    this.loading = false
                })
            }
        },
        reset() {
            this.message_object = {
                attaches: [],
                bcc: "",
                body: '',
                cc: "",
                from: '',
                in_reply_to: '',
                references: '',
                subject: '',
                to: "",
            }
            this.options = []
            this.value = {
                bcc: '',
                cc: '',
                to: '',
            }
            this.$refs.file.parentNode.reset()
        },
    },
    mounted() {
      this.message_object = this.message || this.message_object
      this.value.to = this.message.to.map(t => {
        const [name, email] = get_names_and_email(t)
        return ({name, email})
      })
      this.value.cc = this.message.cc.map(t => {
        const [name, email] = get_names_and_email(t)
        return ({name, email})
      })
      get_signature().then(signature => {
        this.signature = signature
        this.message_object.body = `${this.message_object.body}${this.original_message}${signature}`
      })
      this.$nextTick(() => setTimeout(() => this.$refs.to.$el.focus(), 600))
    },
    props: {
        message: {
            default() {
                return {
                    attaches: [],
                    bcc: "",
                    body: '',
                    cc: "",
                    from: '',
                    subject: '',
                    to: "",
                }
            },
            required: false,
            type: Object,
        },

    },
}
</script>

<style lang="sass" scoped>
div.control
  width: 100%

.compose-box
  .field-autocomplete
    border-bottom: 1px solid #e8e8e8
    display: flex
    .label
      margin: 0
      min-height: 40px
      padding-top: 7px
    .multiselect
      .multiselect__tags
        border: none
  .bcc-cc
    display: flex
    padding: 8px
    a:not(:last-child)
      margin-right: 6px
  .compose-box-buttons
    display: flex
    justify-content: space-between
    padding: 4px
    div:first-child button:first-child, div:last-child button:first-child
      margin-right: 6px
  .remove-attachment-button
    &:hover
      cursor: pointer
</style>